<script>
// import Vue from 'vue'
// Import UI components
import Layout from '@layouts/main.vue'

import menuRoutes from '@router/menuRoutes.js'

import passport from '@assets/svg/passport.vue'
import island from '@assets/svg/island.vue'
import flightTicket from '@assets/svg/flight-ticket.vue'

export default {
  name: 'PaxTotalsMenu',
  components: {
    Layout,
    passport,
    island,
    flightTicket,
  },
  data() {
    return {
      paxRoutes: menuRoutes.navRoutePaxTotals,
    }
  },
  methods: {
    go(route) {
      this.$router.push({ name: route })
    },
  },
}
</script>
<template>
  <div>
    <div v-if="$route.meta.menu === false || !$route.meta.menu">
      <RouterView />
    </div>
    <div v-if="$route.meta.menu === true">
      <Layout>
        <div class="mr-1 mt-5 ml-1 full">
          <div class>
            <div class="container m-auto">
              <h4 class="mb-4">Select a passenger totals report from the below options.</h4>
              <div class="row">
                <div v-for="(item, index) in paxRoutes" :key="index" class="col-md-3 mb-2">
                  <button
                    type="button"
                    class="btn btn-outline-dark btn-lg btn-block mh-auto"
                    style
                    @click="go(item.name)"
                  >
                    <component :is="item.icon" />

                    <div>{{ item.title }}</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  </div>
</template>
